// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"835":"ddb05da9","865":"16afb27e"}[chunkId] + ".css";
};